module.exports = __webpack_public_path__ + "static/media/20200506-3.1c14282b.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20200506/img/20200506-3.png
// module id = 318
// module chunks = 0